<template>
  <!-- 基本資料頁 -->
  <div class="list">
    <ul>
      <li>
        <a href="#" class="item-content">
          <div class="item-media">
            <i class="material-icons">person</i>
          </div>
          <div class="item-inner">
            <div class="item-title">
              <div class="item-header">學號</div>
              <div>{{ studentNo }}</div>
            </div>
          </div>
        </a>
      </li>
      <li>
        <a href="#" class="item-content">
          <div class="item-media">
            <i class="material-icons">school</i>
          </div>
          <div class="item-inner">
            <div class="item-title">
              <div class="item-header">職稱</div>
              <div>{{ posi }}</div>
            </div>
          </div>
        </a>
      </li>
      <li>
        <a href="#" class="item-content">
          <div class="item-media">
            <i class="material-icons">school</i>
          </div>
          <div class="item-inner">
            <div class="item-title">
              <div class="item-header">身份</div>
              <div>{{ type }}</div>
            </div>
          </div>
        </a>
      </li>
      <li>
        <a href="#" class="item-content">
          <div class="item-media">
            <i class="material-icons">account_balance</i>
          </div>
          <div class="item-inner">
            <div class="item-title">
              <div class="item-header">系所</div>
              <div>{{ dept }}</div>
            </div>
          </div>
        </a>
      </li>
      <li>
        <a href="#" class="item-content">
          <div class="item-media">
            <i class="material-icons">phone</i>
          </div>
          <div class="item-inner">
            <div class="item-title">
              <div class="item-header">Phone</div>
              <div>{{ phone }}</div>
            </div>
          </div>
        </a>
      </li>
      <li>
        <a href="#" class="item-content">
          <div class="item-media">
            <i class="material-icons">email</i>
          </div>
          <div class="item-inner">
            <div class="item-title">
              <div class="item-header">Email</div>
              <div>{{ email }}</div>
            </div>
          </div>
        </a>
      </li>
    </ul>
    <div class="block" @click="logout">
      <a href="" class="log-out-button" @click="logout">
        <i class="material-icons">exit_to_app</i>
        <span>登出</span>
      </a>
    </div>
  </div>
</template>

<script>
import Service from "../../service";

export default {
  components: {},
  data() {
    return {
      studentNo: this.$store.state.userInfo.studentNo,
      phone: this.$store.state.userInfo.mobilePhone,
      email: this.$store.state.userInfo.email,
      posi: this.$store.state.userInfo.position,
      dept: this.$store.state.userInfo.department,
      dish: Service.getDish(this.$f7route.params.id),
      type: this.$store.state.userInfo.type
    };
  },
  methods: {
    logout : function() {
      this.$store.dispatch("logoutRemoveTrigger","logout");
      this.$f7router.navigate("/login");
    }
  },
  created() {
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/users/settings-basic.vue